export default "__VITE_ASSET__6cf920d3__"